export interface CommonEcwComponentProps {
    setLoading?: React.Dispatch<React.SetStateAction<boolean>>;
}

export interface EcwFormValues {
    patID: string;
    barcode: string;
    qty: number;
    units: string;
    waste: number;
    accessKey?: string,
    patFName?: string,
    patMName?: string,
    patLName?: string,
    patDOB?: string,
    patGender?: string,
    userID?: string,
    userFName?: string,
    userMName?: string,
    userLName?: string,
    userNum?: string,
    hcpid?: string,
    hcpfName?: string,
    hcpmName?: string,
    hcplName?: string,
    hcpNum?: string,
    serverDate?: string,
    serverTime?: string,
    location?: string,
    query?: string,
    uniqueId?: string,
    inventory?: boolean,
    expiringInventory?: boolean,
    emrOrderId?: string,
    name?: string,
    encounterId?: string,
    encounterDate?: string,
    emrOrderDate?: string,
    reason?: string | null,
    clientId?: string,
    orderId: string;
    orderType: string;
    route: string;
    site: string;
    facilityGuid?: string,
    itemInfo: {
        lotNumber?: string,
        expiration?: string,
        ndcCode?: string,
        manufacturer?: string,
        cvXCode?: string,
        mvxCode?: string,
        mvxManufacturer?: string,
        stock?: string,
        itemName?: string,
        itemType?: string,
    }
}

export const EcwFormInitialValues = {
    patID: "",
    barcode: "",
    qty: 0,
    units: "",
    waste: 0,
    accessKey: "",
    patFName: "",
    patMName: "",
    patLName: "",
    patDOB: "",
    patGender: "",
    userID: "",
    userFName: "",
    userMName: "",
    userLName: "",
    userNum: "",
    hcpid: "",
    hcpfName: "",
    hcpmName: "",
    hcplName: "",
    hcpNum: "",
    serverDate: "",
    serverTime: "",
    location: "",
    query: "",
    uniqueId: "",
    inventory: true,
    expiringInventory: true,
    emrOrderId: "",
    name: "",
    encounterId: "",
    encounterDate: "",
    emrOrderDate: "",
    reason: null,
    clientId: "",
    orderId: "",
    orderType: "",
    route: "",
    site: "",
    facilityGuid: "",
    itemInfo: {
        lotNumber: "",
        expiration: "",
        ndcCode: "",
        manufacturer: "",
        cvXCode: "",
        mvxCode: "",
        mvxManufacturer: "",
        stock: "",
        itemName: "",
        itemType: "",
    }
}

export const AddPatientFormInitialValues = {
    firstName: "",
    lastName: "",
    dob: null as Date | null,
    gender: "",
    patientCode: "",
    isActive: true,
}

export const genderOptions: string[] = ["Male", "Female", "Other"];

export const OrderTypeOptions: { value: string, label: string }[] = [
    { value: "VAC", label: "Vaccine" },
    { value: "MED", label: "Medication" },
    { value: "DME", label: "DME" }
];

export const RouteFieldOptions = [
    { value: "", label: "Please select route" },
    { value: "ID", label: "Intradermal" },
    { value: "IM", label: "Intramuscular" },
    { value: "NS", label: "Nasal" },
    { value: "IV", label: "Intravenous" },
    { value: "PO", label: "Oral" },
    { value: "OTH", label: "Other/Miscellaneous" },
    { value: "SC", label: "Subcutaneous" },
    { value: "TD", label: "Transdermal" },
    { value: "NA", label: "NA" }
]

export const SiteFieldOptions = [
    { value: "", label: "Please select site" },
    { value: "BN", label: "Bilateral Nares" },
    { value: "LA", label: "Left Arm" },
    { value: "LD", label: "Left Deltoid" },
    { value: "LG", label: "Left Gluteus Medius" },
    { value: "LLFA", label: "Left Lower Forearm" },
    { value: "LPC", label: "Left Posterior Chest" },
    { value: "LT", label: "Left Thigh" },
    { value: "LVL", label: "Left Vastus Lateralis" },
    { value: "RA", label: "Right Arm" },
    { value: "RD", label: "Right Deltoid" },
    { value: "RG", label: "Right Gluteus Medius" },
    { value: "RLFA", label: "Right Lower Forearm" },
    { value: "RPC", label: "Right Posterior Chest" },
    { value: "RT", label: "Right Thigh" },
    { value: "RVL", label: "Right Vastus Lateralis" },
    { value: "NA", label: "NA" }
]
export interface EcwOrdersResponse {
    patientMRN?: string;
    firstName?: string;
    lastName?: string;
    gender?: string;
    birthDate?: string;
    orders?: EcwOrder[];
}

export interface EcwOrder {
    facility: {
        facilityId: string;
        facilityName: string;
    };
    loggedUser: {
        lastName: string;
        firstName: string;
        username: string;
    };
    doses: string;
    cvxCode: string;
    provider: {
        npi: string;
        lastName: string;
        firstName: string;
    };
    vfcCode: string;
    encounterDate: string;
    emrJsonId: number;
    encounterId: number;
    vaccineName: string;
    immId: number;
    status: string;
    colour: string;
    ecwResponseMessage?: string | null;
    isSuccess?: boolean | null;
    orderType?: string | null;
    medicationRequest?: {
        fhirId: string;
        intent: string;
        authoredOn: string;
        dosageInstruction: string;
        rxOrderNo: string;
        additionalInstruction: string;
        timingStart: string;
        timingCode: string;
        route: string;
        dosage: number;
        dosageUnit: string;
        medicationId: string | null;
        medicationName: string;
        ndcCode: string;
        rxNormCode: string;
        ecwOrderId: string;
        ecwOrder: any;
        id: string;
        isActive: boolean;
        createdOnUtc: string;
        updatedOnUtc: string | null;
        createdBy: string;
        updatedBy: string | null;
    }
}

export interface EcwOrderResponse {
    isOrderProcessed: boolean;
    ecwResponseMessage: string | null;
}

export interface RecordApiMessages {
    success: string;
    error: string[];
}

export const getOrderKey = (order: EcwOrder) => order?.immId || order?.medicationRequest?.rxOrderNo;